import { GObjectType, GField, GInputType } from "../graphql";

@GObjectType("CoordinatesRecord")
@GInputType("CoordinatesRecordInput")
export class CoordinatesRecord {
  @GField()
  public lat: number;

  @GField()
  public lng: number;

  @GField()
  public timestamp: number;
}
